import React, { FC } from 'react'

type Props = { className?: string }

export const DashboardCardBg: FC<Props> = ({ className }) => {
  return (
    <div className={className}>
      <img src="/img/dashboard-card-bg.webp" alt="ダッシュボードカードの背景画像" />
    </div>
  )
}
